import { z } from 'zod';

import { INDUSTRY_CATALOG } from './catalog/industries';
import { CorrelationMatrixSchema } from './correlation.schema';
import { AreaDiversifierSchema, DIVERSIFIERS_MAX, MEMBERS_MAX, MOVERS_MAX } from './sector.schema';
import { SecuritySchema } from './security.schema';

export const AREA_ID_PATTERN = /^AREA\.(IND|IDX|TH|MKT)\.[A-Z0-9_]+$/u;
export const AreaIdSchema = z.string().regex(AREA_ID_PATTERN).brand<'AreaId'>();
export type AreaId = z.infer<typeof AreaIdSchema>;

const AreaSchema = z.object({
  id: AreaIdSchema,
  name: z.string().min(1).max(100),
});

export const AreaAggregateSchema = AreaSchema.extend({
  mcap: z.number().nonnegative(),
  /** Null means no member carried both market cap and active-window return. */
  ret: z.number().nullable(),
  memberCount: z.number().int().nonnegative(),
  advancers: z.number().int().nonnegative(),
  decliners: z.number().int().nonnegative(),
});
export type AreaAggregate = z.infer<typeof AreaAggregateSchema>;

export const AreaListPayloadSchema = z.object({
  areas: z.array(AreaAggregateSchema).max(INDUSTRY_CATALOG.length),
  unclassifiedCount: z.number().int().nonnegative(),
});
export type AreaListPayload = z.infer<typeof AreaListPayloadSchema>;

export const AreaDetailSchema = z.object({
  area: AreaSchema,
  aggregate: AreaAggregateSchema,
  members: z.array(SecuritySchema).max(MEMBERS_MAX),
  movers: z.array(SecuritySchema).max(MOVERS_MAX),
  matrix: CorrelationMatrixSchema.optional(),
  diversifiers: z.array(AreaDiversifierSchema).max(DIVERSIFIERS_MAX),
});
export type AreaDetail = z.infer<typeof AreaDetailSchema>;
